// Central content + imagery for Fast Fix Charlotte
export const CONTACT = {
  phone: "(704) 201-4261",
  phoneHref: "tel:+17042014261",
  email: "Fastfixcharlotte@gmail.com",
  emailHref: "mailto:Fastfixcharlotte@gmail.com",
  hours: "Mon–Sat · 7:00 AM – 7:00 PM",
  city: "Charlotte, North Carolina",
};

export const SOCIALS = [
  { name: "Google", href: "https://share.google/CSSjvpm2HCBLIvArL", icon: "Google" },
  { name: "Instagram", href: "https://www.instagram.com/fastfix.charlotte", icon: "Instagram" },
  { name: "Facebook", href: "https://www.facebook.com/FastFixCharlotteLLC", icon: "Facebook" },
];

const U = (id, w = 1400) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  heroHome: U("1600566753190-17f0baa2a6c3", 1800),
  heroBuilding: U("1486406146926-c627a92ad1ab", 1200),
  heroTech: U("1581578731548-c64695cc6952", 1000),
  aboutTeam: "/projects/about-team.jpg",
  residential: U("1600607687939-ce8a6c25118c", 1400),
  commercial: U("1497366216548-37526070297c", 1400),
  interior: U("1600566753086-00f18fb6b3ea", 1200),
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    name: "Painting & Drywall",
    icon: "Paintbrush",
    desc: "Professional interior and exterior painting, drywall repair and flawless finishes across Charlotte.",
    items: ["Interior & Exterior Painting", "Drywall Repair", "Drywall Finishing", "Patching", "Texture Matching", "Ceiling Repairs"],
    bg: U("1562259949-e8e7689d7828", 900),
  },
  {
    name: "Feature Walls",
    icon: "Rows3",
    desc: "Custom feature walls in wood slat, board & batten, shiplap, decorative panels and media wall designs.",
    items: ["Wood Slat Walls", "Board & Batten", "Shiplap", "Decorative Wall Panels", "Media Walls", "Custom Feature Walls"],
    bg: "/projects/feature-wall-5.jpg",
  },
  {
    name: "Flooring Installation",
    icon: "Layers",
    desc: "Precision installs and repairs — luxury vinyl plank, laminate, hardwood, tile and baseboards.",
    items: ["Luxury Vinyl Plank (LVP)", "Laminate", "Hardwood", "Tile", "Baseboards", "Transitions", "Floor Repairs"],
    bg: U("1615873968403-89e068629265", 900),
  },
  {
    name: "Kitchen & Bathroom Renovations",
    icon: "Bath",
    desc: "Full kitchen and bathroom remodels — cabinets, vanities, tile, plumbing fixtures and finish work.",
    items: ["Cabinet Installation", "Vanities", "Tile & Backsplashes", "Faucets & Sinks", "Toilets", "Hardware Installation"],
    bg: U("1556911220-bff31c812dba", 900),
  },
  {
    name: "Residential Remodeling",
    icon: "Home",
    desc: "Whole-home and single-room remodels in Charlotte — designed for lasting value and clean execution.",
    items: ["Full Renovations", "Room Additions", "Basement Finishing", "Interior Redesigns", "Trim & Carpentry"],
    bg: U("1600566753086-00f18fb6b3ea", 900),
  },
  {
    name: "Commercial Property Improvements",
    icon: "Building2",
    desc: "Tenant improvements, retail refreshes and office build-outs delivered on schedule.",
    items: ["Tenant Improvements", "Retail Refreshes", "Office Build-outs", "Storefront Upgrades", "Commercial Renovations"],
    bg: U("1497366216548-37526070297c", 900),
  },
  {
    name: "Commercial Property Maintenance",
    icon: "ClipboardCheck",
    desc: "Reliable, low-disruption upkeep programs that keep your business open and looking sharp.",
    items: ["Facility Maintenance", "Office Maintenance", "Retail Repairs", "Ongoing Service Agreements", "Emergency Repairs"],
    bg: U("1497366811353-6870744d04b2", 900),
  },
  {
    name: "Property Maintenance",
    icon: "ShieldCheck",
    desc: "Move-in / move-out repairs, punch lists, seasonal care and ongoing service for landlords and homeowners.",
    items: ["Move-in / Move-out Repairs", "Rental Property Maintenance", "Punch Lists", "Seasonal Maintenance", "Ongoing Property Care"],
    bg: U("1600566753190-17f0baa2a6c3", 900),
  },
  {
    name: "Handyman Services",
    icon: "Wrench",
    desc: "Small jobs handled by the same trusted pros — TV mounting, shelving, fixtures and quick repairs.",
    items: ["TV Mounting", "Furniture Assembly", "Shelving Installation", "Picture Hanging", "Ceiling Fans", "Light Fixtures", "Minor Repairs"],
    bg: U("1581092160562-40aa08e78837", 900),
  },
];

export const WHY = [
  { title: "Residential & Commercial", icon: "Building2", desc: "One partner for homes, offices, retail and managed properties." },
  { title: "Professional Craftsmanship", icon: "Award", desc: "Skilled tradespeople who take pride in every detail." },
  { title: "Transparent Pricing", icon: "ReceiptText", desc: "Clear, upfront quotes with no surprises — ever." },
  { title: "Fast Response", icon: "Zap", desc: "Quick scheduling and prompt, dependable communication." },
  { title: "Reliable Scheduling", icon: "CalendarCheck", desc: "We show up on time and finish when we say we will." },
  { title: "Quality Materials", icon: "PackageCheck", desc: "Premium products selected to last for years to come." },
  { title: "Attention to Detail", icon: "SearchCheck", desc: "The finish is in the details — and we obsess over them." },
  { title: "Customer Satisfaction", icon: "HeartHandshake", desc: "Your satisfaction is guaranteed on every project." },
];

export const STEPS = [
  { n: "01", title: "Request Free Estimate", desc: "Tell us about your project in under two minutes." },
  { n: "02", title: "Receive Transparent Quote", desc: "Get a clear, itemized price with zero pressure." },
  { n: "03", title: "Schedule Your Project", desc: "Pick a time that works — we handle the rest." },
  { n: "04", title: "Enjoy Professional Results", desc: "Sit back and enjoy craftsmanship built to last." },
];

export const COMMERCIAL = [
  "Office Maintenance",
  "Retail Improvements",
  "Tenant Improvements",
  "Facility Repairs",
  "Property Management Services",
  "Recurring Maintenance",
  "Professional Installations",
];

export const AREAS = [
  "Charlotte", "Matthews", "Mint Hill", "Pineville", "Ballantyne",
  "Huntersville", "Concord", "Indian Trail", "Fort Mill", "Gastonia",
];

export const GALLERY = [
  { cat: "Feature Walls", img: "/projects/feature-wall-5.jpg", aspect: "aspect-[4/3]", alt: "Shiplap fireplace feature wall with wood mantle in Charlotte, NC by Fast Fix Charlotte" },
  { cat: "Feature Walls", img: "/projects/feature-wall-1.jpg", aspect: "aspect-[3/4]", alt: "Modern media wall with floating shelves and built-in cabinets in Charlotte, NC by Fast Fix Charlotte" },
  { cat: "Feature Walls", img: "/projects/feature-wall-3.jpg", aspect: "aspect-[4/3]", alt: "Dark vertical shiplap TV feature wall with electric fireplace in Charlotte, NC by Fast Fix Charlotte" },
  { cat: "Feature Walls", img: "/projects/feature-wall-2.jpg", aspect: "aspect-[3/4]", alt: "White shiplap fireplace feature wall with wood mantle and plants in Charlotte, NC by Fast Fix Charlotte" },
  { cat: "Feature Walls", img: "/projects/feature-wall-4.jpg", aspect: "aspect-square", alt: "Tan shiplap media wall with dark wood floating shelves in Charlotte, NC by Fast Fix Charlotte" },
  { cat: "Feature Walls", img: "/projects/accent-5.webp", aspect: "aspect-[4/3]" },
  { cat: "Feature Walls", img: "/projects/accent-1.webp", aspect: "aspect-[3/4]" },
  { cat: "Feature Walls", img: "/projects/accent-3.jpg", aspect: "aspect-[4/3]" },
  { cat: "Feature Walls", img: "/projects/accent-4.webp", aspect: "aspect-video" },
  { cat: "Feature Walls", img: "/projects/accent-6.jpg", aspect: "aspect-[3/4]" },
  { cat: "Feature Walls", img: "/projects/accent-2.webp", aspect: "aspect-[3/4]" },
  { cat: "Feature Walls", img: "/projects/accent-7.webp", aspect: "aspect-[9/16]" },
  { cat: "Shelving", img: "/projects/shelf-1.webp", aspect: "aspect-square" },
  { cat: "Shelving", img: "/projects/shelf-2.webp", aspect: "aspect-square" },
  { cat: "Shelving", img: "/projects/shelf-4.png", aspect: "aspect-square" },
  { cat: "Shelving", img: "/projects/shelf-3.jpg", aspect: "aspect-square" },
  { cat: "Shelving", img: "/projects/shelf-5.webp", aspect: "aspect-[9/20]" },
  { cat: "Kitchen & Bath", img: "/projects/kitchen-1.jpg", aspect: "aspect-square" },
  { cat: "Kitchen & Bath", img: "/projects/kitchen-5.jpg", aspect: "aspect-[16/9]" },
  { cat: "Kitchen & Bath", img: "/projects/kb-7.webp", aspect: "aspect-[9/16]" },
  { cat: "Kitchen & Bath", img: "/projects/kb-9.webp", aspect: "aspect-[9/16]" },
  { cat: "Kitchen & Bath", img: "/projects/kitchen-2.jpg", aspect: "aspect-[3/4]" },
  { cat: "Kitchen & Bath", img: "/projects/kb-6.webp", aspect: "aspect-[9/16]" },
  { cat: "Kitchen & Bath", img: "/projects/kb-8.webp", aspect: "aspect-[9/20]" },
  { cat: "Kitchen & Bath", img: "/projects/kitchen-3.jpg", aspect: "aspect-[9/20]" },
  { cat: "Kitchen & Bath", img: "/projects/kitchen-4.jpg", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-3.webp", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-1.webp", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-4.webp", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-2.webp", aspect: "aspect-[2/1]" },
  { cat: "Painting & Drywall", img: "/projects/paint-5.webp", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-8.jpg", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-7.jpg", aspect: "aspect-[9/20]" },
  { cat: "Painting & Drywall", img: "/projects/paint-6.jpg", aspect: "aspect-[9/20]" },
  { cat: "Outdoor Projects", img: "/projects/outdoor-5.jpg", aspect: "aspect-[4/3]" },
  { cat: "Outdoor Projects", img: "/projects/outdoor-3.jpg", aspect: "aspect-[3/4]" },
  { cat: "Outdoor Projects", img: "/projects/outdoor-4.jpg", aspect: "aspect-[3/4]" },
  { cat: "Outdoor Projects", img: "/projects/outdoor-1.jpg", aspect: "aspect-[9/20]" },
  { cat: "Outdoor Projects", img: "/projects/outdoor-2.jpg", aspect: "aspect-[9/20]" },
  { cat: "Flooring", img: "/projects/floor-3.jpg", aspect: "aspect-[16/9]" },
  { cat: "Flooring", img: "/projects/floor-1.jpg", aspect: "aspect-[16/9]" },
  { cat: "Flooring", img: "/projects/floor-2.jpg", aspect: "aspect-[9/20]" },
  { cat: "Flooring", img: "/projects/floor-4.jpg", aspect: "aspect-[16/9]" },
  { cat: "Flooring", img: "/projects/floor-5.jpg", aspect: "aspect-[16/9]" },
  { cat: "TV Mounting", img: U("1593784991095-a205069470b6", 900) },
  { cat: "Commercial", img: U("1497366811353-6870744d04b2", 900) },
  { cat: "Doors", img: "/projects/door-2.webp", aspect: "aspect-[9/20]" },
  { cat: "Doors", img: "/projects/door-1.webp", aspect: "aspect-[9/20]" },
  { cat: "Trim", img: U("1600210492486-724fe5c67fb0", 900) },
  { cat: "Repairs", img: U("1581092160562-40aa08e78837", 900) },
];

export const REVIEWS = [
  { name: "Marcus Bell", role: "Homeowner · Ballantyne", photo: "https://randomuser.me/api/portraits/men/32.jpg", text: "Fast Fix transformed our main floor with new LVP and fresh paint. The crew was punctual, tidy, and the finish is flawless. Best contractor experience we've had in Charlotte." },
  { name: "Priya Nair", role: "Property Manager · Uptown", photo: "https://randomuser.me/api/portraits/women/44.jpg", text: "We use Fast Fix for all our unit make-readies. Transparent pricing, fast turnarounds and consistent quality. They've become an extension of our team." },
  { name: "David Okafor", role: "Retail Owner · Matthews", photo: "https://randomuser.me/api/portraits/men/68.jpg", text: "They handled our storefront refresh over a weekend so we never lost a day of business. Professional from quote to cleanup. Highly recommended." },
  { name: "Sarah Whitfield", role: "Homeowner · Huntersville", photo: "https://randomuser.me/api/portraits/women/65.jpg", text: "TV mounted, shelves installed, and two doors replaced — all in one visit. Clear pricing and genuinely nice people. I'll never call anyone else." },
  { name: "James Carter", role: "Facilities Lead · Concord", photo: "https://randomuser.me/api/portraits/men/15.jpg", text: "Recurring maintenance across three office sites has never been easier. Reliable scheduling and craftsmanship you can count on every single time." },
];

export const SERVICE_OPTIONS = [
  "General Handyman Services",
  "Painting",
  "Drywall Repair",
  "Flooring Installation (LVP / Laminate)",
  "Kitchen Upgrade",
  "Bathroom Upgrade",
  "TV Mounting",
  "Lighting & Ceiling Fans",
  "Trim, Doors & Carpentry",
  "Furniture / Outdoor Assembly",
  "Commercial / Property Maintenance",
  "Other",
];
